import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

export interface SortableItem {
  setNodeRef: (element: HTMLElement | null) => void
  style: { transform: string | undefined; transition: string | undefined }
  /**
   * Spread onto the drag handle, which must be focusable.
   *
   * On a handle rather than on the row, because a row that is both a link and a
   * drag source has no way to tell Enter-to-open from Enter-to-pick-up.
   */
  handleProps: Record<string, unknown>
  isDragging: boolean
}

export function useSortableItem(id: number): SortableItem {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id })

  return {
    setNodeRef,
    style: { transform: CSS.Transform.toString(transform), transition },
    handleProps: { ...attributes, ...listeners },
    isDragging,
  }
}
